/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SetupModeButton_organization$ref: FragmentReference;
declare export opaque type SetupModeButton_organization$fragmentType: SetupModeButton_organization$ref;
export type SetupModeButton_organization = {|
  +id: string,
  +setupModeEnabled: boolean,
  +setupModeSuspendedInvitationsCount: number,
  +$refType: SetupModeButton_organization$ref,
|};
export type SetupModeButton_organization$data = SetupModeButton_organization;
export type SetupModeButton_organization$key = {
  +$data?: SetupModeButton_organization$data,
  +$fragmentRefs: SetupModeButton_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SetupModeButton_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "setupModeEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "setupModeSuspendedInvitationsCount",
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '14649bfe1486d0396c6f38f6f4844fb4';

module.exports = node;
